<template>
  <input
    type="text"
    :value="formattedValue"
    aria-label="Last name"
    class="form-control"
    @keypress="handleKeyDown"
    @input="handleInput">
</template>

<script>
function getValidPrefixes(prefix) {
  return prefix.toUpperCase().match(/[B-DF-HJ-NP-TV-Z]/g);
}

function getPrefix(value) {
  let prefix = getValidPrefixes(value);
  return Array.isArray(prefix) ? prefix.slice(0, 4).join('') : '';
}

function getNumber(value) {
  return value.replace(/\D/g, '').slice(0, 5);
}

function removeFormat(value) {
  return value.replace('-', '');
}

export default {
  name: 'AppFolioInput',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    formattedValue() {
      const prefix = getPrefix(this.value);
      const number = getNumber(this.value);
      return prefix + '-' + number;
    }
  },
  methods: {
    handleKeyDown(event) {
      const currentValue = removeFormat(event.target.value);
      const key = event.key.toLowerCase();
      const isNumber = key.match(/\d/g);
      const validPrefixes = getValidPrefixes(key);
      const currentPrefix = getPrefix(currentValue);
      const currentNumber = getNumber(currentValue);
      const allowMorePrefixes = currentPrefix.length < 4;
      const allowMoreNumber = (currentNumber + '').length < 5;

      if ((!isNumber && !validPrefixes) || (!allowMorePrefixes && validPrefixes) || (!allowMoreNumber && isNumber)) {
        event.preventDefault();
      }
    },
    handleInput(event) {
      const value = removeFormat(event.target.value);
      if (value === null || value === '') {
        this.$emit('input', '');
        return;
      }

      const prefix = getPrefix(value);
      const number = getNumber(value);
      this.$emit('input', prefix + number);
    }
  }
};
</script>
